import { render, staticRenderFns } from "./addSale.vue?vue&type=template&id=3a65be4c&scoped=true&"
import script from "./addSale.vue?vue&type=script&lang=js&"
export * from "./addSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65be4c",
  null
  
)

export default component.exports